import { Root } from "./Root";
import { Header } from "./Header";
import { NoImage } from "./NoImage";
import { Main } from "./Main";
import { Jobs } from "./Jobs";
import { Images } from "./Images";

export const Galeria = {
    Root,
    Header,
    Main,
    Jobs,
    Images,
    NoImage,
}